/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Ordernr1Inputs */

const en__field_ordernr1 = /** @type {(inputs: _Field_Ordernr1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invoice Nr.`)
};

const de__field_ordernr1 = /** @type {(inputs: _Field_Ordernr1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechunugsnummer`)
};

/**
* | output |
* | --- |
* | "Invoice Nr." |
*
* @param {_Field_Ordernr1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_ordernr1 = /** @type {((inputs?: _Field_Ordernr1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Ordernr1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_ordernr1(inputs)
	return de__field_ordernr1(inputs)
});
export { _field_ordernr1 as "_field_orderNr" }